import React from 'react';
import { ListFieldSection } from 'Components/Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { Field, NumericInput, TextOutput } from 'Components/Core';
import { WorksheetBalanceFieldSet } from '../../../../Core/WorksheetEquipment';

const WashingSection = () => (
  <>
    <ListFieldSection heading="Washing" single>
      <Field input={<NumericInput />} label="Soaking Period" name="Preparation.SoakingPeriod" />
    </ListFieldSection>
    <ListFieldSection>
      <Field
        input={<WorksheetEquipmentDropdown />}
        label="Guard sieve"
        equipmentType="sieve"
        name="Equipment.GuardSieve"
        queryParams={{
          SieveSize: {
            value: '0.425 mm',
            operator: '>=',
          },
        }}
      />
      <Field
        input={<WorksheetEquipmentDropdown />}
        label="Washing sieve"
        equipmentType="sieve"
        name="Equipment.WashingSieve"
        queryParams={{ SieveSize: '75.0 μm' }}
      />
      <WorksheetBalanceFieldSet label="Balance" name="Equipment.WashedBalance" />
      <Field input={<WorksheetEquipmentDropdown />} label="Oven" equipmentType="oven" name="Equipment.WashedOven" />

      <Field input={<NumericInput />} label="Tare and Washed Portion Dry Mass" name="Masses.WashedTareAndDryMass" />
      <Field input={<TextOutput />} label="Washed Portion Dry Mass" name="Masses.WashedDryMass" />
      <Field input={<TextOutput />} label="Mass of Washings" name="Masses.WashingsDryMass" />
    </ListFieldSection>
  </>
);

export { WashingSection };
